// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  PIXABAY_API_KEY: '7566646-5a661965100a8203e96327293',
  PIXABAY_API_URL: 'https://pixabay.com/api/?key='
};



// WEBPACK FOOTER //
// C:/Users/Sai Ashok Kumar/angular-gallery/src/environments/environment.ts